const EmptyPlaceHolderString = () => {
  return (
    <span
      style={{
        color: "rgb(47, 50, 68)",
        fontSize: "12px",
        fontWeight: "600",
        margin: "10px 5px 0 0",
        padding: "6px 15px 9px",
        borderRadius: "14px",
        backgroundColor: "rgb(242, 243, 239)",
      }}
    >
      -
    </span>
  );
};
export default EmptyPlaceHolderString;
